import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    splitter: {
      namespaced: true,
      state: {
        open: false
      },
      mutations: {
        toggle (state, shouldOpen) {
          if (typeof shouldOpen === 'boolean') {
            state.open = shouldOpen
          } else {
            state.open = !state.open
          }
        }
      }
    },
    routerAnim: {
      namespaced: true,
      state: {
        anim: 'slide' // or back
      },
      mutations: {
        set (state, pattern) {
          state.anim = pattern
        }
      }
    },
    tabbar: {
      strict: true,
      namespaced: true,
      state: {
        index: 0
      },
      mutations: {
        set (state, index) {
          state.index = index
        }
      }
    },
    toolbar: {
      strict: true,
      namespaced: true,
      state: {
        title: ''
      },
      mutations: {
        set (state, label) {
          state.title = label
        }
      }
    },
    account: {
      strict: true,
      namespaced: true,
      state: {
        token: ''
      },
      mutations: {
        set (state, dat) {
          state.token = dat
        }
      }
    },
    user: {
      strict: true,
      namespaced: true,
      state: {
        prof: {}
      },
      mutations: {
        set (state, dat) {
          state.prof = dat
        }
      }
    },
    lic: {
      strict: true,
      namespaced: true,
      state: {
        val: null
      },
      mutations: {
        set (state, dat) {
          state.val = dat
        }
      }
    },
    appVersion: {
      strict: true,
      namespaced: true,
      state: {
        val: '0.0.0'
      },
      mutations: {
        set (state, dat) {
          state.val = dat
        }
      }
    },

    isReminderUpdate: {
      strict: true,
      namespaced: true,
      state: {
        flg: false
      },
      mutations: {
        set (state, dat) {
          state.flg = dat
        }
      }
    },
    twitterAuth: {
      strict: true,
      namespaced: true,
      state: {
        val: null
      },
      mutations: {
        set (state, dat) {
          state.val = dat
        }
      }
    },
    isTwitter: {
      strict: true,
      namespaced: true,
      state: {
        flg: false
      },
      mutations: {
        set (state, dat) {
          state.flg = dat
        }
      }
    },

    tabBadgeMessages: {
      strict: true,
      namespaced: true,
      state: {
        badge: ''
      },
      mutations: {
        set (state, dat) {
          state.badge = dat
        }
      }
    },

    mileyInfoUpdateFlag: {
      strict: true,
      namespaced: true,
      state: {
        flg: false
      },
      mutations: {
        set (state, dat) {
          state.flg = dat
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js